import {useContext} from 'react';

import {TableRowContext} from './TableRowContext';

export const useTableRowContext = () => useContext(TableRowContext);
